import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit = 25, completeWords = false, ellipsis = '...') {
    if (completeWords) {
      if (value.length > limit) {
        limit = value.substr(0, limit).lastIndexOf(' ');
      }
    }
    return value.length > limit ? value.substr(0, limit) + ellipsis : value;
  }
}